import React from 'react';

import {
  ButtonVariant as ShadcnButtonVariant,
  Size as ShadcnSize,
  ShadCNButton
} from '@nw/design-system/shadcn';

import { mapSizeToShadcn, mapVariantToShadcn } from './propMappers';
import { ButtonProps } from './types';

export const ShadcnButton: React.FC<ButtonProps> = (props) => {
  const {
    variant,
    size,
    isDisabled,
    isLoading,
    onClick,
    className,
    children,
    id,
    type,
    childrenClassName,
    // Filter out unsupported props for Shadcn
    ref: _ref,
    testId: _testId,
    autoFocus: _autoFocus,
    fillParent: _fillParent,
    leftIcon: _leftIcon,
    rightIcon: _rightIcon,
    color: _color,
    shouldShrinkButtonWhileLoading: _shouldShrinkButtonWhileLoading,
    designSystemType: _designSystemType,
    ...otherProps
  } = props;

  // Map variant from Omega format to Shadcn format
  const shadcnVariant = mapVariantToShadcn(variant) as ShadcnButtonVariant;

  // Map size from Omega format to Shadcn format
  const shadcnSize = mapSizeToShadcn(size) as ShadcnSize;

  return (
    <ShadCNButton
      id={id}
      isDisabled={isDisabled}
      isLoading={isLoading}
      variant={shadcnVariant}
      size={shadcnSize}
      onClick={onClick}
      className={className}
      type={type || 'button'}
      childrenClassName={childrenClassName}
    >
      {children}
    </ShadCNButton>
  );
};
